import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = {
  key: 0,
  class: "col-12"
}
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = ["value", "onBlur", "onFocus"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Укажите дату следующей оплаты", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 text-center" }

import { onMounted, reactive, computed } from 'vue';
import { DatePicker } from 'v-calendar';
import { CURRENCY } from '@depo/constants/purchase';
import { useModal } from '@/composables/useModal';
import api from '@/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'SendPaymentOrderModal',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;

const modal = useModal(props.id);

const state = reactive({
    id: 0,
    file: null,
    amount: '',
    nextDate: '',
    currency: CURRENCY.KZ_TENGE,
    exchangeRate: '1',
    remainingAmount: 0,
    remainingAmountInNativeCurrency: 0,
    totalInNativeCurrency: 0,
    visibleErrors: false,
    loader: false,
});

onMounted(() => {
    state.remainingAmount = modal.data.payment.remainingAmount;
    state.remainingAmountInNativeCurrency = modal.data.payment.remainingAmountInNativeCurrency;
    state.exchangeRate = modal.data.payment.exchangeRate;
    state.totalInNativeCurrency = modal.data.payment.totalInNativeCurrency;
    state.currency = modal.data.payment.currency;
});

const isFullyPaid = computed(() => Number(state.amount) >= state.remainingAmountInNativeCurrency);
const isFileError = computed(() => !state.file);
const isAmountError = computed(() => !+state.amount || Number(state.amount) > state.remainingAmountInNativeCurrency);
const isDateError = computed(() => (!isFullyPaid.value ? state.nextDate.length === 0 : false));
const amountErrorText = computed(() =>
    Number(state.amount) > state.remainingAmount ? 'Сумма превышает остаток' : 'Введите сумму',
);
const isExchangeRateError = computed(() => Number(state.exchangeRate) <= 0);

const isError = computed(() => isFileError.value || isAmountError.value || isDateError.value);

function selectFile(e: any) {
    let file = e.target.files[0];
    state.file = file;
}

function handleExchangeEnter() {
    state.exchangeRate = state.exchangeRate.replaceAll(',', '.');
}

function handleAmountEnter() {
    state.amount = state.amount.replaceAll(',', '.');
}

function send() {
    if (isError.value) {
        state.visibleErrors = true;
        return;
    }

    state.visibleErrors = false;
    state.loader = true;

    let fd = new FormData();
    // @ts-ignore
    fd.append('file', state.file);
    fd.append('id', modal.data.payment.paymentRegisterId);
    fd.append('amount', state.amount);
    fd.append('exchangeRate', state.exchangeRate);
    if (state.nextDate) {
        fd.append('nextDate', state.nextDate);
    }

    api.requestsPayments.pay(fd).then((r) => {
        modal.ok({
            item: r.data,
        });
    });
}

return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-sm",
    title: "Загрузка платежного поручения"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите файл",
              label: "Выберите файл",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  ref: "file",
                  "is-invalid": isFileError.value && state.visibleErrors,
                  type: "file",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (selectFile($event)))
                }, null, 8, ["is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": amountErrorText.value,
              label: "Сумма"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.amount,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.amount) = $event)),
                  "is-invalid": state.visibleErrors && isAmountError.value,
                  mask: { mask: 'Z*', tokens: { Z: { pattern: /^[0-9.,]+$/ } } },
                  maxlength: "12",
                  placeholder: "",
                  onInput: handleAmountEnter
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            }, 8, ["invalid-feedback"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_form_group_ui, { label: "Валюта" }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.currency,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.currency) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Введите курс",
              label: "Курс на дату оплаты"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.exchangeRate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.exchangeRate) = $event)),
                  "is-invalid": state.visibleErrors && isExchangeRateError.value,
                  mask: { mask: 'Z*', tokens: { Z: { pattern: /^[0-9.,]+$/ } } },
                  maxlength: "12",
                  placeholder: "",
                  onInput: handleExchangeEnter
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_form_group_ui, { label: "Остаток" }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  disabled: "",
                  value: state.remainingAmountInNativeCurrency - +state.amount
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          (!isFullyPaid.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_form_group_ui, {
                  "invalid-feedback": "Выберите дату",
                  label: "Дата следующего платежа",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DatePicker), {
                      modelValue: state.nextDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.nextDate) = $event)),
                      class: "inline-block h-full",
                      mode: "date",
                      timezone: 'Asia/Almaty'
                    }, {
                      default: _withCtx(({ inputValue, togglePopover }) => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("input", {
                            class: _normalizeClass(["form-control", { 'is-invalid': isDateError.value && state.visibleErrors, 'bg-white': true }]),
                            value: inputValue,
                            onBlur: ($event: any) => (togglePopover()),
                            onFocus: ($event: any) => (togglePopover())
                          }, null, 42, _hoisted_9),
                          _hoisted_10
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Сохранить ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})